import { forwardRef } from "react";

interface SectionContainerProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

const SectionContainer = forwardRef<HTMLElement, SectionContainerProps>(
  ({ children, className, ...rest }, ref) => (
    <section ref={ref} className={`w-full ${className ?? ""}`} {...rest}>
      <div className="max-w-[1920px] mx-auto h-full">
        <div className="w-full h-full">{children}</div>
      </div>
    </section>
  ),
);

SectionContainer.displayName = "SectionContainer";

export default SectionContainer;
